import Share from 'ninelines-sharing';
import vars from '../helpers';

let $dataSocial = null;

const shareImagesParams = {
	vk: 'image',
	ok: 'imageUrl',
};

const share = (e) => {
	const social = e.currentTarget.dataset.social;
	const url = location.origin + location.pathname + location.search;
	const domain = vars.globalPath === '/' ? location.href : vars.domain;

	if (social === 'vk' || social === 'ok') {
		Share.openWindow(`${Share.getUrl(social, url)}&${shareImagesParams[social]}=${domain}images/share/sh.jpg`, null);
	} else {
		Share[social](url);
	}
};

const init = (container) => {
	$dataSocial = container.querySelectorAll('[data-social]');

	if (!$dataSocial.length) {
		return;
	}

	$dataSocial.forEach(($dataSocialCurrent) => {
		$dataSocialCurrent.addEventListener('click', share);
	});
};

export default {
	init,
};
